export { default as Img200 } from './processed/200/Solo-A-Star-Wars-Story.jpg';
export { default as Img400 } from './processed/400/Solo-A-Star-Wars-Story.jpg';
export { default as Imgthumb } from './processed/thumb/Solo-A-Star-Wars-Story.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Solo-A-Star-Wars-Story.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Solo-A-Star-Wars-Story.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      247,
      220,
      9
    ],
    "_population": 1203,
    "_hsl": [
      0.14775910364145659,
      0.9370078740157481,
      0.5019607843137255
    ]
  },
  "LightVibrant": {
    "_rgb": [
      238,
      197,
      133
    ],
    "_population": 2308,
    "_hsl": [
      0.1015873015873016,
      0.7553956834532375,
      0.7274509803921569
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      113,
      74,
      20
    ],
    "_population": 16,
    "_hsl": [
      0.09677419354838712,
      0.6992481203007519,
      0.26078431372549016
    ]
  },
  "Muted": {
    "_rgb": [
      156,
      95,
      89
    ],
    "_population": 2070,
    "_hsl": [
      0.014925373134328372,
      0.2734693877551021,
      0.4803921568627451
    ]
  },
  "LightMuted": {
    "_rgb": [
      204,
      172,
      164
    ],
    "_population": 1,
    "_hsl": [
      0.03333333333333333,
      0.2816901408450705,
      0.7215686274509805
    ]
  },
  "DarkMuted": {
    "_rgb": [
      105,
      57,
      45
    ],
    "_population": 2637,
    "_hsl": [
      0.03333333333333333,
      0.3999999999999999,
      0.29411764705882354
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Solo-A-Star-Wars-Story.js